module.exports = __webpack_public_path__ + "static/img_1439-c52a94fa20e5b80439e39bf32b32edf4.webp";